/**
 * Parser de vCard (string BEGIN:VCARD...END:VCARD) → { name, number }.
 *
 * Robusto para o que o WhatsApp manda. Pontos importantes:
 *  - NÚMERO: prioriza o `waid=` (WhatsApp ID — o número CANÔNICO, sem máscara
 *    nem DDI duplicado). O campo TEL formatado (ex: "+55 55 9181-0278") às vezes
 *    traz o DDI duplicado ou máscara — o waid é a fonte confiável.
 *  - NOME: usa FN; se o FN for só o número (contato sem nome salvo), deixa vazio
 *    pra UI cair no número.
 *
 * Ex. de vCard problemático que isto resolve:
 *   FN:+5555991810278                         (nome = número malformado)
 *   TEL;type=CELL;waid=555591810278:+55 55... (waid = número correto)
 *   → { name: "", number: "555591810278" }
 */
export function parseVcard(vcard) {
  const text = String(vcard || "");
  const lines = text.split(/\r?\n/);

  let name = "";
  let waid = "";
  let tel = "";

  for (const line of lines) {
    // FN: nome de exibição
    if (/^FN[:;]/i.test(line)) {
      name = line.replace(/^FN[^:]*:/i, "").trim();
    }
    // waid= em qualquer lugar da linha (TEL;...;waid=NNN:+...)
    const waidMatch = line.match(/waid=(\d+)/i);
    if (waidMatch && !waid) waid = waidMatch[1];
    // TEL formatado (fallback se não houver waid)
    if (/^TEL/i.test(line) || /^item\d+\.TEL/i.test(line)) {
      const afterColon = line.split(":").slice(1).join(":");
      const digits = afterColon.replace(/\D/g, "");
      if (digits && !tel) tel = digits;
    }
  }

  const number = waid || tel || "";

  // Se o nome for só o próprio número (com ou sem +), trata como "sem nome".
  const nameDigits = name.replace(/\D/g, "");
  if (nameDigits && (nameDigits === number || nameDigits === tel || `+${nameDigits}` === name)) {
    name = "";
  }

  return { name, number };
}
